// extracted by mini-css-extract-plugin
module.exports = {"container":"hW","title":"hX"};